import { render, staticRenderFns } from "./platformSettlementFund.vue?vue&type=template&id=19451e6f&scoped=true"
import script from "./platformSettlementFund.vue?vue&type=script&lang=js"
export * from "./platformSettlementFund.vue?vue&type=script&lang=js"
import style0 from "./platformSettlementFund.vue?vue&type=style&index=0&id=19451e6f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19451e6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19451e6f')) {
      api.createRecord('19451e6f', component.options)
    } else {
      api.reload('19451e6f', component.options)
    }
    module.hot.accept("./platformSettlementFund.vue?vue&type=template&id=19451e6f&scoped=true", function () {
      api.rerender('19451e6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformManage/settlementFund/platformSettlementFund.vue"
export default component.exports